import { render, staticRenderFns } from "./EnEsperaAutorizado.vue?vue&type=template&id=7949cba0&"
import script from "./EnEsperaAutorizado.vue?vue&type=script&lang=js&"
export * from "./EnEsperaAutorizado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports